export const sortByMenuOrder = (a, b) => (a.menuOrder > b.menuOrder ? 1 : -1);

export const mapStandaloneItems = (standaloneItems, emptyKey) =>
  standaloneItems.map((item) => ({
    category: item.optionName,
    optionPath: item.optionPath,
    [emptyKey]: [],
    menuOrder: item.menuOrder
  }));

export const splitMenuList = (list) => {
  const items = Array.isArray(list) ? list : [];
  const standaloneItems = [];
  const childItems = [];

  items.forEach((item) => {
    if (item.parent === null) {
      standaloneItems.push(item);
    } else {
      childItems.push(item);
    }
  });

  return { standaloneItems, childItems };
};

export default splitMenuList;
